import React, {useRef} from 'react';
import AddButton from "../../Atoms/Buttons/AddButton";
import IconPanelContainer from "../Containers/IconPanelContainer";
import BankItem from "../../Molecules/Items/BankItem";
import NewBankModal from "../Modals/NewBankModal";

const BanksPanel = () => {
  const newBankModal = useRef()

  const handleOpenNewBankModal = () => {
    newBankModal.current.openModal()
  }
  return (
    <>
      <IconPanelContainer
        icon="bank"
        title="Cuentas bancarias"
      >
        <div className="ed-grid rows-gap s-gap-2">
          <AddButton onClick={handleOpenNewBankModal} text="Agrega un banco" />
          <BankItem/>
        </div>
      </IconPanelContainer>
      <NewBankModal ref={newBankModal}/>
    </>
  );
};

export default BanksPanel;
